import AchComponentErroriOS from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_common/componentError.mdx";
import AchComponentStartiOS from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_common/componentStart.mdx";
import AchComponentSubmitiOS from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_common/componentSubmit.mdx";
import AchUserDetailsUpdateCollectedDataiOS from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_ach/achUserDetailsUpdatedCollectedData.mdx";
import AchUserDetailsStepiOS from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_ach/achUserDetailsStep.mdx";
import AchUserDetailsValidationErroriOS from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_ach/achUserDetailsValidationError.mdx";
import PrimerPaymentMethodTypeiOS from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_common/paymentMethodType.mdx";
import * as React from 'react';
export default {
  AchComponentErroriOS,
  AchComponentStartiOS,
  AchComponentSubmitiOS,
  AchUserDetailsUpdateCollectedDataiOS,
  AchUserDetailsStepiOS,
  AchUserDetailsValidationErroriOS,
  PrimerPaymentMethodTypeiOS,
  React
};